let logHistory = '';
export const consoleLog = (...msgs) => {
  // eslint-disable-next-line no-console
  console.log(...msgs);
  logHistory += `${JSON.stringify(msgs)}\n`;
  return logHistory;
};
export const emptyLog = () => undefined;
